import { ButtonGradientPrimary, ButtonSecondary, Colors, Icon, Spinner } from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';

interface FormNavigatorHostedFooterProps {
    onBack: () => void;
    onNext: () => void;
    isNextAvailable: boolean;
    isLoading: boolean;
    isNextDisabled?: boolean;
}

export const FormNavigatorHostedFooter = ({
    onBack,
    onNext,
    isNextAvailable,
    isLoading,
    isNextDisabled = false,
}: FormNavigatorHostedFooterProps) => {
    const { t } = useAmelioTranslations();

    return (
        <div className={'mt-6 flex justify-between gap-2 sm:justify-end'}>
            <ButtonSecondary
                className={'min-w-30 sm:min-w-40'}
                dataTestId={'back-button'}
                onClick={onBack}
                leftIcon={
                    <Icon
                        name={'arrow-arrow-left'}
                        className={'mr-2'}
                    />
                }
            >
                {t('common.back')}
            </ButtonSecondary>

            {isNextAvailable && (
                <ButtonGradientPrimary
                    className={'min-w-30 sm:min-w-40'}
                    dataTestId={'next-button'}
                    onClick={onNext}
                    disabled={isLoading || isNextDisabled}
                    rightIcon={
                        isLoading ? null : (
                            <Icon
                                name={'arrow-arrow-right'}
                                className={'ml-2'}
                                color={Colors.WHITE}
                            />
                        )
                    }
                >
                    {isLoading ? (
                        <Spinner
                            size={'sm'}
                            color={Colors.WHITE}
                        />
                    ) : (
                        t('common.next')
                    )}
                </ButtonGradientPrimary>
            )}
        </div>
    );
};
